// 患者列表
import s400PatientList from '@/components/service/service400/patient/list'

// 患者列表详情
import s400PatientDetail from '@/components/service/service400/patient/detail'
// 随访列表
import s400PatientFollowList from '@/components/service/service400/patient/followList'

// 随访列表详情
import s400PatientFollowDetail from '@/components/service/service400/patient/followDetail'
// 患者新增
import s400PatientForm from '@/components/service/service400/patient/form'
// 随访详情页面
import s400FollowRecordIndex from '@/components/service/service400/followRecord/index'
// 质疑管理
import s400QuestionList from '@/components/service/service400/question/list'

// 患者列表详情-患者首页
import s400PatientSelfDetail from '@/components/service/service400/patient/selfDetail'

let ServiceRouter = [
  {
    path: '/main/service/service400/patient/list',
    name: 's400PatientList',
    component: s400PatientList
  },{
    path: '/main/service/service400/patient/followList',
    name: 's400PatientFollowList',
    component: s400PatientFollowList
  },{
    path: '/main/service/service400/patient/detail',
    name: 's400PatientDetail',
    component: s400PatientDetail
  },{
    path: '/main/service/service400/patient/followDetail',
    name: 's400PatientFollowDetail',
    component: s400PatientFollowDetail
  },{
    path: '/main/service/service400/patient/form',
    name: 's400PatientForm',
    component: s400PatientForm
  },{
    path: '/main/service/service400/followRecord/index',
    name: 's400FollowRecordIndex',
    component: s400FollowRecordIndex
  },{
    path: '/main/service/service400/question/list',
    name: 's400QuestionList',
    component: s400QuestionList
  },{
    path: '/main/service/service400/patient/selfDetail',
    name: 's400PatientSelfDetail',
    component: s400PatientSelfDetail
  }
]

export default ServiceRouter
